/**
 * Global enum for all the app involved actions
 */
var ActionTypes;
(function (ActionTypes) {
    // Search Criteria
    ActionTypes["FETCH_SEARCH_CRITERIA_REQUEST"] = "24-media/searchCriteria/GET_REQUEST";
    ActionTypes["FETCH_SEARCH_CRITERIA_RESPONSE"] = "24-media/searchCriteria/GET_RESPONSE";
    ActionTypes["FETCH_SEARCH_CRITERIA_INVALIDATE"] = "24-media/searchCriteria/GET_INVALIDATE";
    // Newspaper actions
    ActionTypes["FETCH_NEWSPAPERS_GET_REQUEST"] = "24-media/newspapers/GET_REQUEST";
    ActionTypes["FETCH_NEWSPAPERS_GET_RESPONSE"] = "24-media/newspapers/GET_RESPONSE";
    ActionTypes["FETCH_NEWSPAPERS_GET_INVALIDATE"] = "24-media/newspapers/GET_INVALIDATE";
    ActionTypes["FETCH_NEWSPAPER_GET_REQUEST"] = "24-media/newspaper/GET_REQUEST";
    ActionTypes["FETCH_NEWSPAPER_GET_RESPONSE"] = "24-media/newspaper/GET_RESPONSE";
    ActionTypes["FETCH_NEWSPAPER_GET_INVALIDATE"] = "24-media/newspaper/GET_INVALIDATE";
    // News groups actions
    ActionTypes["DERIVE_NEWSGROUPS"] = "24-media/newsGroups/DERIVE";
    // Global app data actions
    ActionTypes["UPDATE_GLOBAL_DATA_SELECTED_CRITERIA"] = "24-media/appGlobalData/UPDATE_SELECTED_CRITERIA";
    ActionTypes["UPDATE_GLOBAL_DATA_SELECTED_NEWS_GROUP"] = "24-media/appGlobalData/UPDATE_SELECTED_NEWS_GROUP";
    ActionTypes["UPDATE_GLOBAL_DATA_SELECTED_DATE"] = "24-media/appGlobalData/UPDATE_SELECTED_DATE";
})(ActionTypes || (ActionTypes = {}));
export default ActionTypes;
